import { TListResponse } from 'src/common/types';
import { TTableSort, TTableSortCols } from 'src/components/table/thead/col';

import { TUserMeta, TUserMetaResponse, adaptUserMetaUndefinedFromResponse } from './user-meta.type';
import { adaptProviderSourceFromResponse, TProviderSource, TProviderSourceResponse } from './provider-source.type';


export const AccountProviderUserListSortCol = {
	NAME: 'name',
	UPDATED_AT: 'updated_at',
	CREATED_AT: 'created_at',
};

export type TAccountProviderUserListSortCol = TTableSortCols<typeof AccountProviderUserListSortCol>;

export type TAccountProviderUserListQuery = {
	limit: number;
	offset: number;
	search?: string;
	sort?: TTableSort;
	sortCol?: TAccountProviderUserListSortCol;
};

export type TAccountProviderUserListQueryRequest = {
	limit?: number;
	offset?: number;
	search?: string;
	sort?: string;
	sort_col?: string;
};

export function adaptAccountProviderUserListQueryToRequest(data?: TAccountProviderUserListQuery): TAccountProviderUserListQueryRequest {
	if (!data) {
		return {};
	}

	const {
		sortCol,
		...restFields
	} = data;

	return {
		sort_col: sortCol,
		...restFields
	};
}

export type TAccountProviderUser = {
  id: number;
  clientId?: string;
  secretKey?: string;
	isActive: boolean;
	createdAt: string;
  updatedAt: string;

  provider: TProviderSource;
	createdBy?: TUserMeta;
	updatedBy?: TUserMeta;
};

export type TAccountProviderUserResponse = {
  id: number;
  client_id?: string;
  secret_key?: string;
	is_active: boolean;
  created_at: string;
  updated_at: string;

  provider: TProviderSourceResponse;
  user: TUserMetaResponse;
	created_by?: TUserMetaResponse;
	updated_by?: TUserMetaResponse;
};

export type TAccountProviderUserListResponse = TListResponse<TAccountProviderUserResponse>;

export type TAccountProviderUserList = TListResponse<TAccountProviderUser>;

export type TAccountProviderUserPayloadRequest = {
	providerId: number;
	clientId?: string;
	secretKey: string;
	isActive: boolean;
};

export type TAccountProviderUserRequest = {
	provider_id: number;
	client_id?: string;
	secret_key: string;
	is_active: boolean;
};

export type TAccountProviderUserPayloadUpdate = {
	id: number;
	data: TAccountProviderUserPayloadRequest;
};

export function adaptAccountProviderUserFromListResponse(data: TAccountProviderUserListResponse): TAccountProviderUserList {
	const {
		items: itemsRaw = [],
		...restFields
	} = data;

	const items = itemsRaw.map(item => adaptAccountProviderUserFromResponse(item));

	return {
		items,
		...restFields
	};
}

export function adaptAccountProviderUserFromResponse(data: TAccountProviderUserResponse): TAccountProviderUser {
	const {
		id,
		client_id: clientId,
		secret_key: secretKey,
		is_active: isActive,
		provider: providerRaw,
		created_at: createdAt,
		updated_at: updatedAt,
		created_by: createdByRaw,
		updated_by: updatedByRaw,
	} = data;

	const provider = adaptProviderSourceFromResponse(providerRaw);
	const createdBy = adaptUserMetaUndefinedFromResponse(createdByRaw);
	const updatedBy = adaptUserMetaUndefinedFromResponse(updatedByRaw);

	return {
		id,
		clientId,
		secretKey,
		isActive,
		provider,
		createdAt,
		updatedAt,
		createdBy,
		updatedBy,
	};
}

export function adaptAccountProviderUserToRequest(data: TAccountProviderUserPayloadRequest): TAccountProviderUserRequest {
	const {
		providerId,
		clientId = undefined,
		secretKey,
		isActive,
	} = data;

	return {
		provider_id: providerId,
		client_id: clientId,
		secret_key: secretKey,
		is_active: isActive,
	};
}
